export const virtualBankData = { enabled: true, bankName: "기업은행", virtualBankAccountNumber: "08205527997844" };

export const paymentOrderData = { amount: 10000, channelType: "PC" };

export const subscriptionOrderData = { amount: 10000, channelType: "PC" };

export const paymentInfoData = {
  remainGCoin: 200,
  subscription: false,
  subscriptionDate: "2025-04-30T10:01:00Z",
  goodsId: 200,
  goodsName: "프리미엄 정액제",
  goodsQuantity: 1,
  paymentAmount: 92000.0,
  minimumAmount: 55000.0,
  
    // "remainGCoin": 312000,
    // "subscription": false,
    // "goodsId": 0,
    // "goodsQuantity": 0,
    // "paymentAmount": 0,
    // "minimumAmount": 0
  
};
